export const DEFAULT_RATIO_THRESHOLDS = {
    horizontal: 1.5,
    vertical: 0.6,
};
export function assignRatioGroup(width, height, thresholds = DEFAULT_RATIO_THRESHOLDS) {
    const ratio = width / height;
    if (ratio >= thresholds.horizontal)
        return 'horizontal';
    if (ratio <= thresholds.vertical)
        return 'vertical';
    return 'square';
}
export const DEFAULT_RATIO_DELTA_TOLERANCES = {
    same: 0.05,
    mild: 0.3,
};
/**
 * Symmetric relative difference between two aspect ratios. Direction-agnostic:
 * a target twice as wide and a target half as wide both yield 1.0 (100%).
 */
export function ratioDelta(sourceRatio, targetRatio) {
    if (!(sourceRatio > 0) || !(targetRatio > 0)) {
        throw new Error(`ratioDelta requires positive ratios, got source=${String(sourceRatio)} target=${String(targetRatio)}`);
    }
    const r = targetRatio / sourceRatio;
    return r >= 1 ? r - 1 : 1 / r - 1;
}
/**
 * Bucket the source→target aspect change into `same` / `mild` / `radical`.
 * Boundaries are inclusive of the lower tier: exactly `same` tolerance is still
 * `same`, exactly `mild` tolerance is still `mild`.
 */
/** Float-slop guard so a delta exactly at a tolerance stays in the lower tier. */
const RATIO_DELTA_EPSILON = 1e-9;
export function classifyRatioDelta(sourceRatio, targetRatio, tolerances = DEFAULT_RATIO_DELTA_TOLERANCES) {
    const delta = ratioDelta(sourceRatio, targetRatio);
    if (delta <= tolerances.same + RATIO_DELTA_EPSILON)
        return 'same';
    if (delta <= tolerances.mild + RATIO_DELTA_EPSILON)
        return 'mild';
    return 'radical';
}
